// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../index';

import { gql } from 'graphql-tag';
import { ImageLargeFragmentDoc } from '../../../components/cms/imageLarge.fragment.generated';
export const MetaFragmentDoc = gql`
    fragment meta on Meta {
  title
  description
  image {
    ...imageLarge
  }
}
    ${ImageLargeFragmentDoc}`;